import { BreakpointObserver, Breakpoints, MediaMatcher } from '@angular/cdk/layout';
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Inject,
    OnChanges,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { asyncScheduler, Subscription } from 'rxjs';
import { observeOn } from 'rxjs/operators';
import { BenachrichtigungenService } from '../../projects/kiene-core/src/lib/benachrichtigungen/benachrichtigungen.service';
import { BenachrichtigungClickEvent } from '../../projects/kiene-core/src/lib/benachrichtigungen/classes/benachrichtigung-click-event';
import { Client } from '../../projects/kiene-core/src/lib/components/client/classes/client';
import { Mandant } from '../../projects/kiene-core/src/lib/components/mandanten/classes/mandant';
import { API_BASE_URL_SERVICE } from '../../projects/kiene-core/src/lib/kiene-core.config';

import { KieneSession } from '../../projects/kiene-core/src/lib/services/local-storage/kiene-session';
import { LocalStorageService } from '../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { MessageService } from '../../projects/kiene-core/src/lib/services/message-service/message.service';
import { UserService } from '../../projects/kiene-core/src/lib/services/user/user.service';
import { environment } from '../environments/environment';
import { versions } from '../environments/versions';
import { ChangeCurrentClientService } from './administration/client/change-current-client/change-current-client.service';
import { AuthGuard } from './app.auth.guard';
import { EntityViewerService } from './components/entity-viewer/entity-viewer.service';
import { KieneTableService } from './components/kiene-table/kiene-table.service';
import { BenutzerrechteDialogComponent } from './dialogs/benutzerrechte-dialog/benutzerrechte-dialog.component';
import { JsonDialogComponent } from './dialogs/json-dialog/json-dialog.component';
import { AutoUploadDialogComponent } from './documents/dokumente/auto-upload-dialog/auto-upload-dialog.component';
import { NavigatorDialogComponent } from './navigator-dialog/navigator-dialog/navigator-dialog.component';
import { KieneNetworkLogEvent, NetworkService } from './services/network.service';
import { LoginService } from '../../projects/kiene-core/src/lib/services/user/login.service';
import { AppService } from '../../projects/kiene-core/src/lib/services/app/app.service';
import { BenachrichtigungDialogComponent } from '../../projects/kiene-core/src/lib/benachrichtigungen/benachrichtigung-dialog/benachrichtigung-dialog.component';
import { ReleaseNotesService } from '../../projects/kiene-core/src/lib/components/release-notes/release-notes.service';
import { PosthogService } from '../../projects/kiene-core/src/lib/services/posthog/posthog.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    host: { '(window:keydown)': 'checkForKeyShortcut($event)' },
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
    title = 'app';
    subTitle = environment.SUB_TITLE;
    colorName = 'primary';
    // infos for current version
    appVersion: string = versions.version;
    commitHash: string = versions.revision;

    @ViewChild('snav') sidenav: MatSidenav;
    @ViewChild(MatSidenavContainer) sidenavContainer: MatSidenavContainer;
    @ViewChild('screen', { static: true }) screen: ElementRef<HTMLDivElement>;

    isDataLoading = false;
    showToolbar = true;

    mobileQuery: MediaQueryList;

    isMobileScreen = false;
    currentClient: Client = new Client();
    currentMandant: Mandant = new Mandant();
    currentUserName = '';
    kieneSession: KieneSession;
    showCurrentClient = false;
    showShoppingCart = false;
    showInventur = false;
    numberOfShoppingCartItems = '0';
    networkLogEvents: KieneNetworkLogEvent[] = [];
    routerEventsSubscription: Subscription;
    showNetworkLog = false;
    isCurrentUserKunde = false;
    isCurrentUserSgs = false;
    isCurrentUserViehhaendler = false;
    public hasCreateHelpPermission: boolean;
    protected readonly environment = environment;
    private readonly _mobileQueryListener: () => void;

    watchCurrentUserSub: Subscription;
    watchDataLoadingSub: Subscription;
    watchCurrentClientSub: Subscription;
    watchShowCurrentClientSub: Subscription;
    watchShowShoppingCartSub: Subscription;
    watchNumberOfShoppingCartItemsSub: Subscription;
    watchChangeCurrentMandantSub: Subscription;
    watchEventSub: Subscription;
    watchBenachrichtigungClickEventSub: Subscription;
    watchLoggedInSub: Subscription;

    constructor(
        private readonly titleService: Title,
        private readonly currentClientService: ChangeCurrentClientService,
        protected router: Router,
        private readonly authGuard: AuthGuard,
        private readonly cdr: ChangeDetectorRef,
        media: MediaMatcher,
        public dialog: MatDialog,
        private readonly localStorageService: LocalStorageService,
        private readonly userService: UserService,
        private readonly appService: AppService,
        private readonly breakpointObserver: BreakpointObserver,
        private readonly entityViewerService: EntityViewerService,
        private readonly networkLogEvent: NetworkService,
        private readonly kieneTableService: KieneTableService,
        private readonly benachrichtigungenService: BenachrichtigungenService,
        private readonly messageService: MessageService,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly loginService: LoginService,
        private readonly releaseNotesService: ReleaseNotesService,
        posthogService: PosthogService,
    ) {
        this.mobileQuery = media.matchMedia('(max-width: 600px)');
        this._mobileQueryListener = () => this.cdr.detectChanges();
        this.mobileQuery.addListener(this._mobileQueryListener);

        this.breakpointObserver.observe(Breakpoints.Handset).subscribe(response => {
            this.isMobileScreen = response.matches;
        });

        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.routerEventsSubscription = this.router.events.subscribe({
            next: event => {
                if (event instanceof NavigationEnd) {
                    this.router.navigated = false;
                    if (this.router.url === '/') {
                        const routeStartseite = this.localStorageService.getStartseite();
                        if (routeStartseite && routeStartseite.length > 1) {
                            this.router.navigate([routeStartseite]).then();
                        }
                    }
                }
                if (this.router.url.startsWith('/sign')) {
                    this.showToolbar = false;
                } else {
                    this.showToolbar = true;
                }
            },
        });
    }

    toggleEntityViewer() {
        this.entityViewerService.toggleVisible();
    }

    setSession(session: KieneSession) {
        this.kieneSession = session;
        if (this.kieneSession) {
            this.currentUserName = this.kieneSession.vorname + ' ' + this.kieneSession.nachname;
            this.isCurrentUserKunde = this.localStorageService.isCurrentUserKunde();
            this.isCurrentUserSgs = this.localStorageService.isCurrentUserSgs();
            this.isCurrentUserViehhaendler = this.localStorageService.isCurrentUserViehhaendler();

            if (this.kieneSession.passwort_aendern > 0) {
                this.userService.neuesPasswortVergeben(this.kieneSession.benutzer_id).subscribe({
                    next: (result: boolean) => {
                        if (result === true) {
                            this.kieneSession.passwort_aendern = 0;
                            this.localStorageService.setCurrentUser(this.kieneSession);
                        }
                        this.releaseNotesService.scheduleCheck();
                    },
                });
            } else {
                this.releaseNotesService.scheduleCheck();
            }
        } else {
            this.currentUserName = undefined;
            this.isCurrentUserKunde = false;
            this.isCurrentUserSgs = false;
            this.isCurrentUserViehhaendler = false;
        }
    }

    istCurrentUserKundeOderViehhaendler() {
        return this.isCurrentUserKunde || this.isCurrentUserViehhaendler;
    }

    ngOnInit() {
        this.setSession(this.localStorageService.getCurrentUser());
        this.hasCreateHelpPermission = this.localStorageService.currentUserHasPermission(402);

        this.colorName = environment.production ? 'primary' : 'warn';
        let title = 'VETVET. ' + this.appVersion;
        if (!environment.production) {
            title = 'TEST ' + title;
        }
        this.titleService.setTitle(title);
        this.currentMandant = this.localStorageService.getCurrentMandant();
        this.currentClient = this.localStorageService.getCurrentClient();

        this.watchCurrentUserSub?.unsubscribe();
        this.watchCurrentUserSub = this.localStorageService.watchCurrentUser().subscribe((data: KieneSession) => {
            this.setSession(data);
        });

        this.watchDataLoadingSub?.unsubscribe();
        this.watchDataLoadingSub = this.appService
            .watchDataLoading()
            .pipe(observeOn(asyncScheduler))
            .subscribe(dataLoading => {
                this.isDataLoading = dataLoading;
                this.cdr.markForCheck();
            });

        this.redirectIfCurrentClientModulBlocked();

        this.watchCurrentClientSub?.unsubscribe();
        this.watchCurrentClientSub = this.localStorageService.watchCurrentClient().subscribe(client => {
            this.currentClient = client;
            this.redirectIfCurrentClientModulBlocked();
        });

        this.watchShowCurrentClientSub?.unsubscribe();
        this.watchShowCurrentClientSub = this.localStorageService.watchShowCurrentClient().subscribe(show => {
            this.showCurrentClient = show;
        });

        this.watchShowShoppingCartSub?.unsubscribe();
        this.watchShowShoppingCartSub = this.localStorageService.watchShowShoppingCart().subscribe((show: boolean) => {
            this.showShoppingCart = show;
        });

        this.watchNumberOfShoppingCartItemsSub?.unsubscribe();
        this.watchNumberOfShoppingCartItemsSub = this.localStorageService
            .watchNumberOfShoppingCartItems()
            .subscribe(items => {
                this.numberOfShoppingCartItems = items.toString();
            });

        this.watchChangeCurrentMandantSub?.unsubscribe();
        this.watchChangeCurrentMandantSub = this.localStorageService.watchChangeCurrentMandant().subscribe(mandant => {
            this.currentMandant = mandant;

            // hier wurde die falsche API genutzt!!
            if (this.localStorageService.currentUserHasPermission(4431)) {
                this.kieneTableService.get(`${this.apiBaseUrl}inventur_eintrag/read_aktiv.php`).subscribe(kieneApi => {
                    if (kieneApi.records?.length > 0) {
                        this.showInventur = true;
                    }
                });
            }
        });

        this.watchEventSub?.unsubscribe();
        this.watchEventSub = this.networkLogEvent.watchEvent().subscribe(event => {
            this.networkLogEvents.unshift(event);
        });

        this.watchBenachrichtigungClickEventSub?.unsubscribe();
        this.watchBenachrichtigungClickEventSub = this.benachrichtigungenService
            .watchBenachrichtigungClickEvent()
            .subscribe({
                next: event => {
                    this.handleBenachrichtigungClickEvent(event);
                },
            });
    }

    ngAfterViewInit() {
        this.watchLoggedInSub?.unsubscribe();
        this.watchLoggedInSub = this.localStorageService.watchLoggedIn().subscribe(loggedIn => {
            this.showToolbar = loggedIn;
        });
    }

    currentUserIsVet() {
        return this.localStorageService.getCurrentUser()?.tierarzt_id || 0;
    }

    showMyVetStock() {
        this.router.navigate(['/startseite/meinbestand']);
    }

    closeSidenav() {
        this.sidenav.close();
    }

    isMenuVisible(menu: string): boolean {
        return this.localStorageService.currentUserCanSeeMenu(menu);
    }

    laborLagerSichtbar(): boolean {
        return (
            this.localStorageService.hasPermission(1082) && !this.localStorageService.hasPermission(1081)
        );
    }

    private redirectIfCurrentClientModulBlocked() {
        if (!this.localStorageService.isCurrentClientFreigabe()) {
            return;
        }
        if (this.router.url.startsWith('/belege') && !this.localStorageService.isCurrentClientModulAllowed('belege')) {
            const fallback = this.localStorageService.isCurrentClientModulAllowed('tierbewegung')
                ? '/gruppen/aktuelle'
                : this.localStorageService.getModulBlockedFallbackUrl();
            void this.router.navigateByUrl(fallback);
        } else if (
            this.router.url.startsWith('/gruppen') &&
            !this.localStorageService.isCurrentClientModulAllowed('tierbewegung')
        ) {
            void this.router.navigateByUrl(this.localStorageService.getModulBlockedFallbackUrl());
        }
    }

    isLoggedIn() {
        if (this.authGuard.isLoggedIn()) {
            return true;
        }
        return false;
    }

    isCurrentUserPhitoUser(): boolean {
        return this.localStorageService.isCurrentUserPhitoUser();
    }

    sessionRefresh() {
        this.loginService.reloadSession().subscribe({
            next: (erfolgreich: boolean) => {
                if (erfolgreich === true) {
                    this.messageService.infoMessage('Session wurde erfolgreich aktualisiert!');
                    location.reload();
                } else {
                    this.messageService.alertMessage('Session konnte nicht aktualisiert werden!');
                }
            },
        });
    }

    showReleaseNotes(): void {
        this.releaseNotesService.showManually();
    }

    public logout() {
        this.router.navigate(['/login']);
    }

    ngOnDestroy(): void {
        this.routerEventsSubscription?.unsubscribe();
        this.watchCurrentUserSub?.unsubscribe();
        this.watchDataLoadingSub?.unsubscribe();
        this.watchCurrentClientSub?.unsubscribe();
        this.watchShowCurrentClientSub?.unsubscribe();
        this.watchShowShoppingCartSub?.unsubscribe();
        this.watchNumberOfShoppingCartItemsSub?.unsubscribe();
        this.watchChangeCurrentMandantSub?.unsubscribe();
        this.watchEventSub?.unsubscribe();
        this.watchBenachrichtigungClickEventSub?.unsubscribe();
        this.watchLoggedInSub?.unsubscribe();
    }

    checkForKeyShortcut(event: KeyboardEvent) {
        if (event.key === 'F2') {
            if (this.sidenav.opened) {
                this.sidenav.close();
            } else {
                this.sidenav.open();
            }
        }
        if (event.altKey && event.code === 'KeyB') {
            this.openChangeClientDialog();
            // this.openBetriebAuswaehlenDialog();
        } else if (event.altKey && event.code === 'KeyM') {
            this.openSelectMandantDialog();
        } else if (event.altKey && event.code === 'KeyP') {
            this.openNavigatorDialog();
        } else if (event.altKey && event.code === 'KeyA') {
            this.openNewAbgabebeleg();
        } else if (event.altKey && event.code === 'KeyR') {
            this.openBenutzerrechteDialog();
        } else if (event.altKey && event.code === 'KeyL') {
            // bei MacOS ist es das @
            // this.logout();
        } else if (event.altKey && event.code === 'KeyN') {
            this.showNetworkLog = !this.showNetworkLog;
            //} else if (event.altKey && event.code === 'KeyH') {
            //    this.router.navigate([this.getLinkForFirstTab('heimtiere')]);
        } else if (event.altKey && event.code === 'Digit1') {
            this.router.navigate([this.getLinkForFirstTab('startseite')]);
        } else if (event.altKey && event.code === 'Digit2') {
            this.router.navigate([this.getLinkForFirstTab('stammdaten', 'betriebe')]);
        } else if (event.altKey && event.code === 'Digit3') {
            this.router.navigate([this.getLinkForFirstTab('lager')]);
        } else if (event.altKey && event.code === 'Digit4') {
            this.router.navigate([this.getLinkForFirstTab('wawi')]);
        } else if (event.altKey && event.code === 'Digit5') {
            this.router.navigate([this.getLinkForFirstTab('belege', 'abgabebelege')]);
        } else if (event.altKey && event.code === 'Digit6') {
            this.router.navigate([this.getLinkForFirstTab('labor')]);
        } else if (event.altKey && event.code === 'Digit7') {
            this.router.navigate([this.getLinkForFirstTab('finanzen')]);
        } else if (event.altKey && event.code === 'Digit8') {
            this.router.navigate([this.getLinkForFirstTab('administration')]);
        } else if (event.altKey && event.code === 'Digit9') {
            this.router.navigate([this.getLinkForFirstTab('reporte')]);
        } else if (event.altKey && event.code === 'Digit0') {
            this.router.navigate([this.getLinkForFirstTab('gruppen')]);
        } else if (event.altKey && event.code === 'Minus') {
            // Logistik vorerst ausgeblendet (ALT + ß)
            // this.router.navigate([this.getLinkForFirstTab('logistik')]);
        }
    }

    openNewAbgabebeleg() {
        this.router.navigate(['/belege/abgabebelege/neu']);
    }

    openNavigatorDialog() {
        this.dialog.open(NavigatorDialogComponent, { minWidth: '400px', width: '50%' });
    }

    openBenutzerrechteDialog() {
        this.dialog.open(BenutzerrechteDialogComponent);
    }

    getLinkForFirstTab(nameOfNavItem: string, presetValue?: string): string {
        const session: KieneSession = this.localStorageService.getCurrentUser();

        if (session == null || !session.menue) {
            return '';
        }

        if (nameOfNavItem === 'lager' && this.laborLagerSichtbar()) {
            const lagerTabs: string[] = session.menue['lager'] || [];
            if (!lagerTabs.includes('wareneingang')) {
                return '/lager/wareneingang';
            }
        }

        const tabs: string[] = session.menue[nameOfNavItem];
        if (tabs && tabs.length > 0) {
            // benutzer mit der rolle 'Verwaltung' sollen bei wawi zuerst den Tab Bestellung-Extern sehen
            // 28.04.2023: Aktuell hat Verwaltung gar kein Recht mehr fuer Bestellung-Extern.
            if (nameOfNavItem === 'wawi' && this.localStorageService.isCurrentUserVerwaltung()) {
                // return '/wawi/bestellung-extern';
                return '/wawi/bestellung-intern';
            }
            if (nameOfNavItem === 'gruppen' && this.localStorageService.isCurrentClientSchwein()) {
                const schweinTab =
                    presetValue && tabs.includes(presetValue) && presetValue !== 'dashboard'
                        ? presetValue
                        : tabs.find(tab => tab !== 'dashboard') ?? 'aktuelle';
                return '/' + nameOfNavItem + '/' + schweinTab;
            }
            if (nameOfNavItem === 'gruppen' && tabs.includes('dashboard')) {
                return '/gruppen/dashboard';
            }
            if (nameOfNavItem === 'reporte') {
                if (this.localStorageService.canAccessReporteDashboard()) {
                    return '/reporte/dashboard';
                }
                const firstOther = tabs.find(tab => tab !== 'dashboard');
                const tab = presetValue && tabs.includes(presetValue) && presetValue !== 'dashboard' ? presetValue : firstOther;
                if (!tab) {
                    return '/reporte/tierarzt';
                }
                return '/reporte/' + (tab === 'waren' ? 'wareneinsatz' : tab);
            }
            return '/' + nameOfNavItem + '/' + (presetValue && tabs.includes(presetValue) ? presetValue : tabs[0]);
        }
        return '';
    }

    openChangeClientDialog() {
        this.currentClientService.openChangeDialog();
    }

    openSelectMandantDialog() {
        this.currentClientService.openChangeMandantDialog(false, this.localStorageService.getCurrentUser());
    }

    showWarenkorb() {
        // Laborleitung ohne Praxis-Einkauf: nur Labor-Warenkorb (Soft-Trennung 1082 ohne 1081)
        const laborOnly =
            this.localStorageService.hasExplicitPermission(1082) &&
            !this.localStorageService.hasExplicitPermission(1081);
        this.router.navigate([laborOnly ? '/wawi/warenkorb-labor' : '/wawi/warenkorb/']);
    }

    laborWarenkorbTooltip(): string {
        const laborOnly =
            this.localStorageService.hasExplicitPermission(1082) &&
            !this.localStorageService.hasExplicitPermission(1081);
        return laborOnly ? 'Labor-Bestellungswarenkorb anzeigen' : 'Warenkorb anzeigen';
    }

    openUploadDocumentDialog() {
        this.dialog.open(AutoUploadDialogComponent, {
            width: '50%',
            minWidth: '300px',
            data: { apiUrl: 'dokument/create_auto.php' },
        });
    }

    goToInventur() {
        this.router.navigate(['/lager/inventur/']).then();
    }

    alert(event: KieneNetworkLogEvent) {
        this.dialog.open(JsonDialogComponent, { data: { text: event?.network.body } });
    }

    private handleBenachrichtigungClickEvent(event: BenachrichtigungClickEvent) {
        if (event) {
            const benachrichtigung = event.benachrichtigung;
            if (benachrichtigung?.gruppe_id) {
                if (benachrichtigung.gt_id) {
                    this.router
                        .navigate(['/gruppen/aktuelle', benachrichtigung.gruppe_id.toString()], {
                            queryParams: { search: benachrichtigung.ohrmarke_notnull.slice(-10) },
                        })
                        .then();
                } else {
                    this.router
                        .navigate(['/gruppen/aktuelle', benachrichtigung.gruppe_id.toString()], {
                            queryParams: { search: ' ' },
                        })
                        .then();
                }
            } else if (benachrichtigung?.tierliste_id) {
                this.router
                    .navigate(['/gruppen/dashboard'], {
                        queryParams: { tierlisteId: benachrichtigung.tierliste_id },
                    })
                    .then();
            } else if (benachrichtigung?.buchungs_id) {
                if (this.localStorageService.getCurrentUser()?.benutzerrollen.find(e => e.benutzerrolle_id == 20)) {
                    this.router
                        .navigate(['viehhaendler/anfrage-details/', benachrichtigung.buchungs_id.toString()])
                        .then();
                } else if (
                    this.localStorageService.getCurrentUser()?.benutzerrollen.find(e => e.benutzerrolle_id == 22)
                ) {
                    this.router
                        .navigate(['schlachthoefe/anfrage-details/', benachrichtigung.buchungs_id.toString()])
                        .then();
                } else {
                    this.router.navigate(['gruppen/anfrage-details/', benachrichtigung.buchungs_id.toString()]).then();
                }
            } else if (benachrichtigung?.ticket_id) {
                this.dialog.open(BenachrichtigungDialogComponent, { width: '500px', data: benachrichtigung });
            }
        }
    }

    isLoginPage(): boolean {
        const url = this.router.url;
        return (
            ['/login', '/register', '/password/reset', '/password/renew', '/initial-setup', '/initial-setup/menu'].some(
                route => url === route,
            ) || url.startsWith('/password/renew/')
        );
    }
}
